
import { Link } from 'react-router-dom';

interface FooterProps {
  onNavigate: (id: string) => void;
}

export default function Footer({ onNavigate }: FooterProps) {
  return (
    <footer className="relative bg-[#0A0A14] border-t border-white/[0.06] overflow-hidden">
      {/* Subtle violet glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-[#7B3FE4]/5 rounded-full blur-[80px] pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-8">
        {/* Main footer row */}
        <div className="flex flex-col sm:flex-row items-center sm:justify-between gap-8 py-12 border-b border-white/[0.06]">
          {/* Left — Logo + Tagline */}
          <div className="flex flex-col gap-2"><img src="/logo.svg" alt="IntevoLabs" style={{ height: "26px", width: "auto" }} /></div>

          {/* Center — Nav links in Spanish */}
          <nav className="flex items-center gap-10">
            <button
              onClick={() => onNavigate('services')}
              className="text-[#8887A0] hover:text-[#F0EFF8] transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Sora, sans-serif', fontSize: '13px' }}
            >
              Servicios
            </button>
            <button
              onClick={() => onNavigate('process')}
              className="text-[#8887A0] hover:text-[#F0EFF8] transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Sora, sans-serif', fontSize: '13px' }}
            >
              Proceso
            </button>
            <button
              onClick={() => onNavigate('contact')}
              className="text-[#8887A0] hover:text-[#F0EFF8] transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Sora, sans-serif', fontSize: '13px' }}
            >
              Contacto
            </button>
          </nav>

          {/* Right — Social icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/intevolabs"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 flex items-center justify-center border border-white/[0.06] hover:border-[#7B3FE4]/40 hover:bg-[#7B3FE4]/5 transition-all duration-200 cursor-pointer"
              style={{ borderRadius: '2px' }}
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-[#8887A0] hover:text-[#7B3FE4] text-base transition-colors duration-200"></i>
            </a>
            <a
              href="https://x.com/intevolabs"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 flex items-center justify-center border border-white/[0.06] hover:border-[#7B3FE4]/40 hover:bg-[#7B3FE4]/5 transition-all duration-200 cursor-pointer"
              style={{ borderRadius: '2px' }}
              aria-label="Twitter / X"
            >
              <i className="ri-twitter-x-line text-[#8887A0] hover:text-[#7B3FE4] text-base transition-colors duration-200"></i>
            </a>
            <a
              href="https://www.instagram.com/intevolabs/#"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 flex items-center justify-center border border-white/[0.06] hover:border-[#7B3FE4]/40 hover:bg-[#7B3FE4]/5 transition-all duration-200 cursor-pointer"
              style={{ borderRadius: '2px' }}
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-[#8887A0] hover:text-[#7B3FE4] text-base transition-colors duration-200"></i>
            </a>
          </div>
        </div>

        {/* Bottom bar — copyright + legal links */}
        <div className="flex flex-col sm:flex-row items-center sm:justify-between gap-4 py-6">
          <p
            className="text-[#8887A0]"
            style={{ fontFamily: 'Sora, sans-serif', fontSize: '13px' }}
          >
            © 2026 Intevo Labs. Todos los derechos reservados.
          </p>

          <div className="flex items-center gap-8">
            <Link
              to="/politica-de-privacidad"
              className="text-[#8887A0] hover:text-[#F0EFF8] transition-colors duration-200 cursor-pointer"
              style={{ fontFamily: 'Sora, sans-serif', fontSize: '13px' }}
            >
              Política de privacidad
            </Link>
            <Link
              to="/terminos-de-uso"
              className="text-[#8887A0] hover:text-[#F0EFF8] transition-colors duration-200 cursor-pointer"
              style={{ fontFamily: 'Sora, sans-serif', fontSize: '13px' }}
            >
              Términos de uso
            </Link>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#8887A0] hover:text-[#7B3FE4] transition-colors duration-200 cursor-pointer"
              style={{ fontFamily: 'Sora, sans-serif', fontSize: '13px' }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}